import { useId, useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import {
  CameraDark,
  Edit,
  ShareIcon,
} from "../../../../components/styled/AllImages";
import {
  Box,
  ButtonStyled,
  HeadingStyled,
  SpanStyled,
} from "../../../../components/styled/Elements";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../../../context/userContext";
import getCroppedImg from "../../../../utils";
import { Modal } from "react-bootstrap";
import { resolveMediaUrl } from "../../../../utils/mediaUrl";

const UpdateCoverImage = ({ handleCoverUpdate, cameraImage }) => {
  const { user } = useUser();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewImg, setPreviewImg] = useState(
    user?.cover ? resolveMediaUrl(user?.cover) : null
  );
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [showCropper, setShowCropper] = useState(false);
  const [loading, setLoading] = useState(false);
  const uniqueId = useId();

  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileURL = URL.createObjectURL(file);
      setSelectedImage(fileURL);
      setShowCropper(true);
    }
    event.target.value = null;
  };

  const handleModalClose = () => {
    setShowCropper(false);
    setCrop({ x: 0, y: 0 })
    setZoom(1)
    setCroppedAreaPixels(null)
    setPreviewImg(user?.cover ? resolveMediaUrl(user?.cover) : null);
  };

  const handleCropSave = async () => {
    try {
      setLoading(true);
      const croppedBlob = await getCroppedImg(selectedImage, croppedAreaPixels);
      const croppedFile = new File([croppedBlob], "cover.jpg", {
        type: "image/jpeg",
      });

      const newImageUrl = URL.createObjectURL(croppedBlob);
      setPreviewImg(newImageUrl); // ✅ update preview

      await handleCoverUpdate({ cover: croppedFile }); // ✅ send to server
      setShowCropper(false); // ✅ close modal
    } catch (e) {
      console.error("Cropping failed:", e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className="bannerImg">
      {previewImg && <img src={previewImg} />}

      <Box className="editBanner">
        {cameraImage && (
          <ButtonStyled
            onClick={() =>
              document.getElementById(`imageInput-${uniqueId}`).click()
            }
            icon={CameraDark}
            bg="var(--white)"
            color="var(--darkGrey)"
            padding="8px 18px"
            size="14px"
          />
        )}
      </Box>

      <input
        id={`imageInput-${uniqueId}`}
        type="file"
        accept="image/png, image/jpeg, image/jpg"
        style={{ display: "none" }}
        onChange={handleFileChange}
      />

      {/* ✅ Modal for Cropping */}
      <Modal
        show={showCropper}
        onHide={handleModalClose}
        centered
        size="lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title className="w-100">
            <HeadingStyled>{t("adjust_cover_photo_title")}</HeadingStyled>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ height: "400px" }} className="mb-4">
          <Box className="mb-2">
            <SpanStyled>{t("adjust_cover_photo_instruction")}</SpanStyled>
          </Box>
          <Box className="h-100 position-relative">
            <Cropper
              image={selectedImage}
              crop={crop}
              zoom={zoom}
              aspect={4 / 1}
              showGrid={true}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={onCropComplete}
            />
          </Box>
        </Modal.Body>

        <Modal.Footer className="d-flex justify-content-end gap-2">
          <ButtonStyled
            onClick={handleModalClose}
            type="button"
            bg="var(--white)"
            border="var(--border)"
            color="var(--darkGrey)"
            label={t("Cancel")}
          />
          <ButtonStyled
            onClick={handleCropSave}
            padding="8px 18px"
            label={t("confirm")}
            isLoading={loading}
          />
        </Modal.Footer>
      </Modal>
    </Box>
  );
};

export default UpdateCoverImage;

// import { useId, useState } from "react";
// import {
//   CameraDark,
//   Edit,
//   ShareIcon,
// } from "../../../../components/styled/AllImages";
// import {
//   Box,
//   ButtonStyled,
//   SpanStyled,
// } from "../../../../components/styled/Elements";
// import { useTranslation } from "react-i18next";
// import { useNavigate } from "react-router-dom";
// import { useUser } from "../../../../context/userContext";

// const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL;

// const UpdateCoverImage = ({ handleCoverUpdate, cameraImage }) => {
//   const { user } = useUser();
//   const { t } = useTranslation();
//   const navigate = useNavigate();
//   const [selectedImage, setSelectedImage] = useState(
//     user?.cover ? resolveMediaUrl(user?.cover) : null
//   );
//   const uniqueId = useId();

//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       handleCoverUpdate({ cover: file });
//       const fileURL = URL.createObjectURL(file);
//       setSelectedImage(fileURL);
//     }
//   };
//   return (
//     <Box className="bannerImg">
//       {selectedImage && <img src={selectedImage} />}

//       {/* <SpanStyled className="share-icon px-3 py-2 bg-white rounded-2">
//         <ShareIcon />
//       </SpanStyled> */}
//       <Box className="editBanner">
//         {cameraImage && (
//           <ButtonStyled
//             onClick={() =>
//               document.getElementById(`imageInput-${uniqueId}`).click()
//             }
//             //   onClick={() => navigate("/profile")}
//             //   label={t("edit_profile")}
//             icon={CameraDark}
//             bg="var(--white)"
//             color="var(--darkGrey)"
//             padding="8px 18px"
//             size="14px"
//           />
//         )}
//       </Box>
//       <input
//         id={`imageInput-${uniqueId}`} // Use the unique ID here
//         type="file"
//         accept="image/png, image/jpeg, image/jpg" // Accept only image files
//         style={{ display: "none" }}
//         onChange={handleFileChange}
//       />
//     </Box>
//   );
// };
// export default UpdateCoverImage;
